import * as React from "react";
import styled from "styled-components";
import { Color, FontWeight } from "@glossy";
import { dominant } from "@glossy/theme";
import Markdown from "@ui-kit/markdown";

const StyledMarkdown = styled(Markdown)`
  overflow-y: auto;
  height: 100%;

  a {
    text-decoration: underline;
    color: ${dominant};
  }

  p,
  dd,
  dt,
  div,
  table,
  blockquote,
  pre,
  code,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    :not(:last-child) {
      margin: 0 0 16px 0;
    }
  }

  ul {
    list-style: disc outside;
  }

  ol {
    list-style: decimal;
  }

  hr {
    border-bottom: 1px solid #d0d7dd;
    margin: 16px 0;
  }

  code {
    background-color: #eef1f2;
  }

  h1,
  h3,
  h4,
  h5,
  h6 {
    font-size: 16px;
    font-weight: ${FontWeight.Bold};
  }

  h2 {
    font-weight: 600;
    font-size: 1.5em;
    border-bottom: 1px solid #ebeef1;
  }

  span.highlighted {
    color: ${Color.PacificBlue};
    display: inline-flex;
    height: 20px;
  }
`;

interface IProps {
  md: string;
}

const RadarlyCardsMarkdown = ({ md }: IProps) => <StyledMarkdown md={md} />;

export default RadarlyCardsMarkdown;
